<template>
  <div :class="classes(n())">
    <div
      v-if="title || $slots.title"
      :class="classes(n('title'), [padded, n(`title--padded`)])"
    >
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <div :class="classes(n('content'))">
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, provide } from 'virtual-vue';
import { props } from './cell-group-props';
import { createNamespace } from '../utils/components';
const { name, n, classes } = createNamespace('cell-group');

export default defineComponent({
  name,
  props,
  setup(props) {
    provide('cellGroup', props);

    return {
      n,
      classes,
    };
  },
});
</script>
